import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styles from './LeadModal.module.scss';

interface LeadModalProps extends PropsWithChildren {
    title: string;
    footer: ReactNode;
    className?: string;
    zIndex?: number;
    onClose?: () => void;
}

const LeadModal: FunctionComponent<LeadModalProps> = props => {
    return createPortal(
        <div
            className={styles.overlay}
            style={props.zIndex !== undefined ? { zIndex: props.zIndex } : undefined}
        >
            <div className={clsx(styles.modal, props.className)}>
                <div className={styles.header}>
                    <h2 className={styles.title}>{props.title}</h2>
                    <FontAwesomeIcon
                        icon={faTimes}
                        fontSize={20}
                        width={20}
                        height={20}
                        onClick={props.onClose}
                        className={styles.closeIcon}
                    />
                </div>
                <div className={styles.body}>{props.children}</div>
                <div className={styles.footer}>{props.footer}</div>
            </div>
        </div>,
        document.body
    );
};

export default LeadModal;
